export const currentAgentPhoneRentalsHeaders = [
  {
    text: "Date",
    value: "date"
  },
  {
    text: "Location Code",
    value: "locationCode"
  },
  {
    text: "First Name",
    value: "firstName"
  },
  {
    text: "Last Name",
    value: "lastName"
  },
  {
    text: "Phone #",
    value: "phoneNumber"
  }
];
